module.exports = __webpack_public_path__ + "SCTProfessional/static/dist/img/strumenti_pic.1d3e6f39.png";